import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { IUser } from '@boma/administration-portal/shared/entities';
import { APP_CONFIG } from '@boma/app-config';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private base: string;
  private version: string;
  constructor(
    @Inject(APP_CONFIG) private configuration: any,
    private httpClient: HttpClient
  ) {
    this.base = configuration.apiRoute;
    this.version = configuration.apiVersion;
  }

  loadUser() {
    return this.httpClient.get<IUser>(
      `${this.base}api/v${this.version}/Profiles/me`
    );
  }
}
